import api from './api';

export const uploadService = {
  // Upload single file
  uploadFile: async (file, type = 'general') => {
    const formData = new FormData();
    formData.append('file', file);
    
    // The backend has a simple /api/upload endpoint
    const response = await api.post('/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Upload multiple files
  uploadMultiple: async (files, type = 'general') => {
    const formData = new FormData();
    files.forEach(file => {
      formData.append('files', file);
    });
    
    const response = await api.post(`/upload/${type}/multiple`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Upload for specific entity
  uploadForEntity: async (file, entityType, entityId) => {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await api.post(`/upload/entity/${entityType}/${entityId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Delete file
  deleteFile: async (fileId) => {
    const response = await api.delete(`/upload/${fileId}`);
    return response.data;
  },

  // Get file URL
  getFileUrl: (filename) => {
    return `${process.env.REACT_APP_API_BASE_URL.replace('/api', '')}/uploads/${filename}`;
  }
};
